<template>
    <footer id="wrapper">
    <div class="container">
    <div class="row">
            <div class="col-md-3 col-sm-4 col-6 collFT">
                <div id="text-3" class="widget widget_text">
                    <div class="textwidget">
                        <p class="logo-footer">
                            <img :src="mmSiteUrl +'wp-content/themes/Mentor-Mentee/img/Large_Logo_White.png'" alt="Mentor Mentee">
                        </p>
                        <p>The Ultimate Technical Mentoring Platform</p> 
                    </div>
                </div>
            </div>
                        <div class="col-md-3  col-sm-4  col-6">
                            <div class="col-md-6 collFT content-text-sections">              
                                    <div class="menu-footer-menu-container"><ul id="menu-footer-menu" class="nav"><li id="menu-item-187" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-187"><a :href="mmSiteUrl +'about/'">About Us</a></li>
<li id="menu-item-188" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-188"><a :href="mmSiteUrl +'contact-us/'">Contact Us</a></li>
<li id="menu-item-189" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-189"><a :href="mmSiteUrl +'faq/'">FAQ</a></li>
</ul></div> 
                            </div>

                            <div class="col-md-6 collFT content-text-sections">              
                                    <div class="menu-footer-menu-2-container"><ul id="menu-footer-menu-2" class="nav"><li id="menu-item-603" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-603"><a :href="mmSiteUrl +'pricing/'">Pricing</a></li>
<!-- <li id="menu-item-634" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-634"><a :href="mmSiteUrl +'seminar/'">Seminar</a></li> -->
</ul></div> 
                            </div>
                        </div>
            <div class="clearfix visible-sm-block" style="margin: 20px 0px;"></div>
            <div class="col-md-2  col-sm-4 col-6 collFT">
                <ul class="list-unstyled social-icons font-24">
                    <li><a href="https://www.linkedin.com/company/mentormentee" target="_blank"><i class="fa fa-linkedin"></i>LinkedIn</a></li>
                </ul>
            </div>
            <div class="clearfix visible-sm-block" style="margin: 20px 0px;"></div>
            <div class="col-md-2  col-sm-6  col-6 collFT">
                <div id="text-4" class="widget widget_text">
                <div class="textwidget">
<!--                                    <p class="footer-address">PO Box 4467 <br />Olathe, KS 66063</p>-->
                    
                </div>
            </div>
        </div>
        <div class="clearfix visible-xs-block" style="margin: 20px 0px;"></div>
        <div class="col-md-2  col-sm-6  col-12 collFT cta-buttonz">
            <ul class="list-inline">
                <li class="margin-bottom-20 text-align-right">
                                    <a href="https://apps.apple.com/in/app/mentormentee/id1541844880" target="_blank"><img :src="mmSiteUrl +'wp-content/themes/Mentor-Mentee/img/app-store-icon-159x47.png'" alt="apple store"></a>
                </li>
                <li class="margin-bottom-20 text-align-right">
                    <a href="https://play.google.com/store/apps/details?id=org.nativescript.mentoring" target="_blank"><img :src="mmSiteUrl +'wp-content/themes/Mentor-Mentee/img/google-play-badge-159x47.png'" width="159" height="47" alt="google play store"></a>
                </li>
            </ul>
        </div>
            <div style="clear: both"></div>
    </div>
    <hr>
    <p class="bottom-fotter-menu">
        © Mentor Mentee  2023 | 
        <a :href="mmSiteUrl +'privacy-policy'">Privacy Policy</a> | 
        <a :href="mmSiteUrl +'terms-of-service'">Terms Of Service</a>
    </p>
   </div>
 </footer>
</template>

<style scoped>
/* Footer Styles */

footer {

    padding: 50px 0;
    background-color: #00ACEE;
    color: #fff;
    font-size: 14px;

}

footer .nav > li > a {padding: 0px;}
footer .nav > li > a:hover, footer .nav > li > a:focus {background-color: transparent; text-decoration:underline;}
footer .nav > li { text-align: left;}

footer a, footer a:hover, footer a:focus { color: #fff;}
footer h2 { margin-top: 0px; text-transform:uppercase; font-size: 24px;}
footer .fa {width: 20px;}
.logo-footer img {
    width: 134px;
    height: auto;
}
footer .nav {
    padding-left: 0 !important; 
    margin-bottom: 0 !important;
    list-style: none;
    display: block;
}
.nav>li>a {
    position: relative;
    display: block;
 }
 footer .col-md-6, footer .col-md-3 {
    float: left;
 }
footer hr {
   border-top: 1px solid #e3e3e3;  
}
.cta-buttonz img {
    height: 36px;
    width: auto;
} 
 @media (min-width: 1200px){
     footer .container {
        max-width: 1170px !important; 
     }
 }    
/* Mobile */
@media (max-width: 320px) {
    .contact-footer { font-size: 12px; }
}
.cta-buttonz {
    margin-top: -2px!important;
}
.cta-buttonz {
    float: right;
    margin-top: 3px;
    text-transform: uppercase;
    margin-right: 0px;
}
ul {
    margin-top: 0;
    margin-bottom: 10px;
}
.list-inline {
    padding-left: 0;
    margin-left: -5px;
    list-style: none;
}
.list-inline>li {
    display: inline-block;
    padding-right: 5px;
    padding-left: 5px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
.cta-buttonz {
    text-align: center;
}
}
</style>
<script>
export default {
    props: ['mmSiteUrl']
}
</script>


// WEBPACK FOOTER //
// src/components/mm_footer.vue